import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const JobSeeking = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobPosition: "",
    resume: null,
    message: "",
  });
  const [status, setStatus] = useState(""); // To manage submission status

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      resume: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare form data
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("name", formData.name);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("phone", formData.phone);
    formDataToSubmit.append("jobPosition", formData.jobPosition);
    formDataToSubmit.append("resume", formData.resume);
    formDataToSubmit.append("message", formData.message);

    try {
      const response = await fetch("https://formspree.io/f/{your-form-id}", {
        method: "POST",
        body: formDataToSubmit,
      });

      if (response.ok) {
        setStatus("success");
        setFormData({
          name: "",
          email: "",
          phone: "",
          jobPosition: "",
          resume: null,
          message: "",
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className="w-full bg-gradient-to-r from-blue-50 to-blue-100 flex flex-col">
      <Header />
      <main className="py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold text-gray-700 text-center mb-6">
            Job Application Form
          </h2>

          {status && (
            <div
              className={`text-center p-4 mb-6 ${
                status === "success"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {status === "success"
                ? "Your application has been submitted successfully!"
                : "Something went wrong. Please try again."}
            </div>
          )}

          <form
           
            action="https://formsubmit.co/shubham@edgecoretechno.com"
            method="POST"
            enctype="multipart/form-data"
            className="space-y-6"
          >
            {/* Personal Details */}
            <div className="space-y-4 text-black">
              <label htmlFor="name" className="block text-gray-600 font-medium">
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Enter your full name"
              />
            </div>

            <div className="space-y-4 text-black">
              <label htmlFor="email" className="block text-gray-600 font-medium">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Enter your email address"
              />
            </div>

            <div className="space-y-4 text-black">
              <label htmlFor="phone" className="block text-gray-600 font-medium">
                Phone Number
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Enter your phone number"
              />
            </div>

            {/* Job Position */}
            <div className="space-y-4 text-black">
              <label htmlFor="jobPosition" className="block text-gray-600 font-medium">
                Position Applied For
              </label>
              <input
                type="text"
                id="jobPosition"
                name="jobPosition"
                value={formData.jobPosition}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Job position you are applying for"
              />
            </div>

            {/* Resume Upload */}
            <div className="space-y-4">
              <label htmlFor="resume" className="block text-gray-600 font-medium">
                Upload Resume
              </label>
              <input
                type="file"
                id="resume"
                name="resume"
                onChange={handleFileChange}
                required
                className="w-full p-3 border border-gray-300 rounded-md"
              />
            </div>

            {/* Message */}
            <div className="space-y-4 text-black">
              <label htmlFor="message" className="block text-gray-600 font-medium">
                Additional Information
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Any additional information you want to add"
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-blue-500 text-white p-4 rounded-md hover:bg-blue-600"
              >
                Submit Application
              </button>
            </div>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default JobSeeking;
